import React from "react";

import isFunction from "lodash/isFunction";

// Safely clone zero or more elements.  The `props` parameter accepts either
// a set of properties to pass to cloned elements, or a function to generate props
// to pass to children.
export default (elements, props, children) => {
  if (!elements) return [];

  // handle elements being only one child
  const arr = Array.isArray(elements) ? elements : [elements];

  return arr.map((element, index) => {
    // handle false-y elements
    if (!element) return false;

    // either clone with index as key or clone with value of passed in function
    return React.cloneElement(element, isFunction(props) ? props(element, index) : { key: index, ...props }, children || element.props.children);
  });
};
